import React from 'react';
import '../App.css';
import './project1.css';
import Sams_cut from '../images/SamsCut4_6.mp4'; 
import Phone from '../images/phone.png';
import Screen_shot1 from '../images/Mobile_tree-1.webp';
import Comp from '../images/computer_portfolio.png';
import Comp_Screen from '../images/Sams_Tree_Service.png';
import Phone2 from '../images/holding_phone.png';
import Screen_shot2 from '../images/Mobile_tree2.webp'; 
import Comp2 from '../images/apple.png';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js' 

const Project1 = () => {

    useScrollBehavior();

	return (
		<div id='project_div1'>
			<div className='module_project' id='project_moduleOne'>
				<div id='project_div2'>
					<video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
					<source src={Sams_cut} type="video/mp4" fetchpriority="high"/>
    						Your browser does not support the video tag.
  					</video>
					<div id='project_div2_heading_container'>
					<div id='project_div2_heading1'>
						<h1>Sam's Tree Service</h1>
					</div>
					<div id='project_div2_heading2'>
						<h3>Scope: Website / WebDev, Hosting, Search Engine Optimization</h3>
						<a className="href_project" href="https://samstreeservice.com/">
                        <h3>Website: https://samstreeservice.com</h3></a>
					</div>
					
					<div id='project_div2_heading3'>
						<p>Sam's Tree project is a licensed, insured and locally owned tree project company, 
							who proudly deliver top-rated tree project to residential
							and commercial clients in Sarasota and across Southwest 
							Florida. Thier project include tree removal, trimming, stump 
							grinding, debris cleanup, and 24/7 emergency assistance, with 
							expert crane project for even the toughest jobs.</p>
					</div>
					</div>
					<div className="phone-frame">
  						<img src={Phone} alt="Phone Frame" className="frame" />
  						<img src={Screen_shot1} alt="Screen Content" className="screen" />
					</div>

					
				</div>
					
				
			</div>
			<div className='module_project' id='project_moduleTwo'>
				<div id='project_mod2_container'>
					<div id='project_mod2_inner1'>
						<h1 id='about_h1'>About the Project</h1>
						<h1>Sam's Tree project</h1>
					</div>
					<div id='project_mod2_inner2'>
						<p>We empowered Sam's Tree project to grow its online presence 
							by implementing custom web development with fullstack capabilites, SEO, and 
							robust hosting solutions. By building a user-friendly
							and search-engine-optimized website, we've helped them 
							attract more clients and solidify their standing in the 
							competitive tree project industry.</p>
					</div>
				</div>

			</div>
			<div className='module_project' id='project_moduleThree'>
				<div id="mod3_container">
  					<div className="frame-container">
                	{/* Computer frame image */}
                		<img src={Comp} alt="Computer Frame" className="computer-frame" />

                		{/* Computer screen content */}
                		<div className="screen-content">
                    		<img src={Comp_Screen} alt="Screenshot inside computer screen" />
                		</div>
            		</div>
				</div>
			</div>
			<div className='module_project' id='project_moduleFour'>
				<div id='mod4_container'>
					
					<div id='mod4_div2_5'>
						<div className="frame-container_mod4">
                		{/* Computer frame image */}
                		<img src={Comp2} alt="Computer Frame2" className="computer-frame2" />

                		{/* Computer screen content */}
                		<div className="screen-content2">
                    		<img src={Comp_Screen} alt="Screenshot inside computer screen2" />
                		</div>
            		</div>

					</div>
					<div id='mod4_div3'>
						<div className="phone-frame2">
  							<img src={Phone2} alt="Phone Frame2" className="frame2" />
  							<img src={Screen_shot2} alt="Screen Content2" className="screen2" />
						</div>

					</div>
				</div>
			</div>
			<Footer/>
			
		</div>
	);
};

export default Project1;